import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';

import { ModalSelectUserComponent } from 'src/app/shared/components/modal-select-user/modal-select-user.component';

export interface ModalSelectUserConfig {
  ignoreIds?: number[];
  unitHash?: string;
  selectOne?: boolean;
}

@Injectable()
export class ModalSelectUserService {
  constructor(
    private modalService: BsModalService
  ) { }

  public show(config: ModalSelectUserConfig): Promise<{ id: number, name: string, email: string }[]> {
    return new Promise((resolve, reject) => {
      const modal = this.modalService.show(ModalSelectUserComponent, { class: 'modal-md' });
      modal.content.setOption(resolve, reject, config);
    });
  }
}
